import { ModalDialog } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Children, JSX, isValidElement } from "react";
import "./Styles.scss";
import { DialogContent } from "./DialogContent";
import { DialogFooter } from "./DialogFooter";
import { Stack } from "../../Layout/Stack/Stack";

export class Dialog extends BaseComponent<IDialogProps, IDialogState>
{
    public componentDidMount(): void
    {
        this.checkChildren();
    }

    public componentDidUpdate(prevProps: IDialogProps): void
    {
        if (prevProps.children != this.props.children)
        {
            this.checkChildren();
        }
    }

    private checkChildren(): void
    {
        const children = Children.toArray(this.props.children);
        if (children.length != 2 || !isValidElement(children[0]) || children[0].type != DialogContent || !isValidElement(children[1]) || children[1].type != DialogFooter)
        {
            throw new Error('Dialog must contain one DialogContent and one DialogFooter, in that order.');
        }
    }

    public render(): JSX.Element
    {
        return (
            <ModalDialog
                {...this.props}
                cancelButtonLabel=''
                submitButtonLabel=''
                onButtonClick={() => { }}
                title={this.props.title ?? ''}
                className={`${this.props.className ?? ''} serendie-dialog serendie-dialog--width-${this.props.lg ?? 6} serendie-dialog--z-index-${this.props.zIndex ?? 1000}`}
            >
                <Stack
                    spacing={2}
                >
                    {this.props.children}
                </Stack>
            </ModalDialog>
        )
    }
}

export interface IDialogProps extends Omit<React.ComponentProps<typeof ModalDialog>, 'title' | 'cancelButtonLabel' | 'submitButtonLabel' | 'onButtonClick'>
{
    title?: string;
    lg?: (1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12);
    zIndex?: (1 | 10 | 100 | 1000 | 10000 | 100000);
}

export interface IDialogState
{
}
